import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FileInput, TabPanel } from '../../../FlowConfigurationInputs';
import { CodeEditor } from '../../../FlowConfigurationInputs/CodeEditor/CodeEditor';
import { RadioOption, RadioPicker } from '../../../FlowConfigurationInputs/RadioPicker/RadioPicker';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @param       showAlert - show alert
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Open({ action, showAlert, setOpenVariable, variables, automId }) {
    const { t } = useTranslation();
    const [value, setValue] = useState(action.fields.filetab?.value ? action.fields.filetab.value : 'file');
    const [tab, setTab] = useState(action.fields.tab?.value ? action.fields.tab.value : 'import');
    const label = 'CONTENT.CONFIGURATION-FORM.PYTHON.OPEN.';
    const options = {
        fileInput: {
            checkExtension: (ext) => {
                if (ext !== 'js') {
                    showAlert(t('CONTENT.CONFIGURATION-FORM.JAVASCRIPT.OPEN.UPLOAD-JAVASCRIPT-ONLY'));
                    return false;
                }
                return true;
            },
            fileType: '.js'
        }
    };
    function handleChangeTabs(v) {
        if (v === 'text') {
            action.fields.filePath = { type: 'TEXT', isRequired: true };
        } else {
            action.fields.filePath = { type: 'FILE', isRequired: true };
        }
        action.fields.filetab = { value: v };
        setValue(v);
    }
    const handleChange = (e) => {
        let v = e.target.value;
        action.fields.tab = { value: v };
        if (v === 'manual') {
            if (action.fields.script) {
                action.fields.script.isRequired = true;
            } else {
                action.fields.script = { value: '', isRequired: false };
            }
            delete action.fields.filePath.isRequired;
        } else {
            action.fields.filePath.isRequired = true;
            delete action.fields.script.isRequired;
        }
        setTab(v);
    };
    return (
        <RadioPicker value={tab} onChange={handleChange}>
            <RadioOption value="import">
                <div className="form-element">
                    {t(label + 'FILE-PATH')}
                    <div className="condition-tabs">
                        <button disabled={tab !== 'import'}
                            className={value === 'file' ? 'condition-active' : ''}
                            onClick={() => handleChangeTabs('file')}>
                            {t(label + 'SELECT-FILE')}
                        </button>
                        <button disabled={tab !== 'import'}
                            className={value === 'text' ? 'condition-active' : ''}
                            onClick={() => handleChangeTabs('text')}>
                            {t(label + 'CUSTOM-STRING')}
                        </button>
                    </div>
                    <TabPanel value={value} index={'file'}>
                        <FileInput action={action} inputName="filePath" options={options.fileInput} isRequired isSize={true} disabled={tab !== 'import'} />
                    </TabPanel>
                    <TabPanel value={value} index={'text'}>
                        <TextInput action={action} inputName="filePath" isRequired={false} setOpenVariable={setOpenVariable} variables={variables} disabled={tab !== 'import'} autom_id={automId} />
                    </TabPanel>
                </div>
            </RadioOption>
            <RadioOption value="manual" active={tab === 'manual'}>
                <div className="form-element">
                    {t(label + 'MANUAL')}
                    <CodeEditor action={action} inputName="script" variables={variables} setOpenVariable={setOpenVariable} multiline disabled={tab !== 'manual'} isRequired />
                </div>
            </RadioOption>
            <div className="form-element">
                {t(label + 'ASSIGN')}
                <VariablePicker action={action} inputName="set" variables={variables} setOpenVariable={setOpenVariable} isRequired />
            </div>
        </RadioPicker>
    );
}
export default Open;